import { Collapse, Row, Col, Tag, Popconfirm, Table, message, notification } from "antd";
import axios from "axios";
import React, { Component } from "react";
import { connect } from "react-redux";
import {
  dineroDisabledMask,
  ModalItem,
  ButtonItem,
} from "../../../../Components/Items";
import moment from "moment";
import ModalEditarDatosFactura from "../../../../Components/ModalEditarDatosFactura";
import RelacionarEntregasModal from "../RelacionarEntregasModal/RelacionarEntregasModal";

const { Panel } = Collapse;

class FacturasOrdenDeCompra extends Component {
  formRef = React.createRef();
  state = {
    loading: false,
    pagosHtml: <p>No se encontro ninguna factura</p>,
    confirmacionVisible: false,
    confirmacionLoading: false,
    confirmacionData: null,
    facturaIdAConfirmar: null,
    modalEditarDatos: false,
    modalEditarDatosId: null,
    modalEntregas: false,
    modalEntregasFactura: null,
  };
  componentDidUpdate(prevProps) {
    if (this.props.visible !== prevProps.visible && this.props.visible)
      this.consultarTodo();
  }

  verFacturaOrdenDeCompra(id) {
    this.props.history.push('/panel/verFacturaOrdenDeCompra', { id })
  }

  abrirEditarDatosFactura(id) {
    this.setState({ modalEditarDatos: true, modalEditarDatosId: id });
  }

  cerrarEditarDatosFactura(recargar = false) {
    this.setState({ modalEditarDatos: false, modalEditarDatosId: null });
    if (recargar) this.consultarTodo();
  }

  abrirRelacionarEntregas(factura) {
    this.setState({ modalEntregas: true, modalEntregasFactura: factura });
  }

  cerrarRelacionarEntregas() {
    this.setState({ modalEntregas: false, modalEntregasFactura: null });
  }

  cancelarFacturaOrdenDeCompra(id, confirmarPolizaTransito = false) {
    if (confirmarPolizaTransito) {
      this.setState({ confirmacionLoading: true });
    } else {
      this.setState({ loading: true });
    }
    axios
      .post(
        "ordenesdecompra/cancelarFacturaOrdenDeCompra",
        {
          facturaId: id,
          empresaId: this.props.empresaId,
          ...(confirmarPolizaTransito ? { confirmarPolizaTransito: true } : {}),
        },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.success === 2) {
          message.success("Factura cancelada");
          this.setState({
            loading: false,
            confirmacionLoading: false,
            confirmacionVisible: false,
            confirmacionData: null,
            facturaIdAConfirmar: null,
          });
          this.consultarTodo();
        } else if (res.data.success === 3) {
          this.setState({
            loading: false,
            confirmacionLoading: false,
            confirmacionVisible: true,
            confirmacionData: {
              message: res.data.message,
              recepcionesAfectadas: res.data.recepcionesAfectadas || [],
              totalSaldoTransito: res.data.totalSaldoTransito || 0,
            },
            facturaIdAConfirmar: id,
          });
        } else if (res.data.success === 1) {
          this.setState({ loading: false, confirmacionLoading: false });
          notification.error({
            message: "Error",
            description: res.data.message || "No se pudo cancelar la factura",
            duration: 6,
          });
        } else {
          this.setState({ loading: false, confirmacionLoading: false });
          message.error("Error al cancelar la factura");
        }
      })
      .catch(() => {
        this.setState({ loading: false, confirmacionLoading: false });
        message.error("Error al cancelar la factura");
      });
  }

  confirmarCancelacionConPoliza = () => {
    if (!this.state.facturaIdAConfirmar) return;
    this.cancelarFacturaOrdenDeCompra(this.state.facturaIdAConfirmar, true);
  };

  cerrarConfirmacion = () => {
    this.setState({
      confirmacionVisible: false,
      confirmacionData: null,
      facturaIdAConfirmar: null,
    });
  };

  async consultarTodo() {
    this.setState({ loading: true });
    await axios
      .post(
        "ordenesdecompra/facturasOrdenDeCompra",
        { ordenId: this.props.id, empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.status === 404){
            this.setState({ pagosHtml: <p>No se encontro ninguna factura</p> });
            return;
        } else {
          const html = (
            <Collapse style={{ marginBottom: 10 }}>
              {res.data.map((valueFactura) => {
                return (
                  <Panel
                    extra={
                      valueFactura.estado !== 0 ? (
                        valueFactura.moneda.abreviacion + ' - ' + dineroDisabledMask(valueFactura.totalPagar)
                      ) : (
                        <Tag color="red">
                          Cancelada: {valueFactura.moneda.abreviacion + ' - ' + dineroDisabledMask(valueFactura.totalPagar)}
                        </Tag>
                      )
                    }
                    header={moment(valueFactura.fechaFactura).locale("es").format("ll")}
                    key={valueFactura._id}
                  >
                    <Row>
                      <Col span={12}>
                        <p>
                          Fecha Factura:{" "}
                          {moment(valueFactura.fechaFactura).locale("es").format("ll")}
                        </p>
                        {valueFactura.estado !== 0 && valueFactura.estadoPago === 0 && (
                          <Popconfirm
                            title="Seguro que quieres cancelar la factura?"
                            onConfirm={() => this.cancelarFacturaOrdenDeCompra(valueFactura._id)}
                            okText="Si"
                            cancelText="No"
                          >
                            <ButtonItem rojo type="primary">
                              Cancelar Factura
                            </ButtonItem>
                          </Popconfirm>
                        )}
                      </Col>
                      <Col span={12}>
                        <p>
                          Dia de registro:{" "}
                          {moment(valueFactura.createdAt).locale("es").format("ll")}
                        </p>
                        {valueFactura.estadoFactura !== 0 && (
                          <ButtonItem type="primary" onClick={() => this.verFacturaOrdenDeCompra(valueFactura._id)}>
                            Ver Factura
                          </ButtonItem>
                        )}
                        {valueFactura.estado !== 0 && this.props.permisoEditarFacturasOrdenDeCompra && (
                          <ButtonItem
                            type="primary"
                            naranja
                            onClick={() => this.abrirEditarDatosFactura(valueFactura._id)}
                          >
                            Editar Datos
                          </ButtonItem>
                        )}
                        {valueFactura.estado !== 0 && this.props.permisoRelacionarEntregasFactura && (
                          <ButtonItem
                            type="primary"
                            verde
                            onClick={() => this.abrirRelacionarEntregas(valueFactura)}
                          >
                            Entregas
                          </ButtonItem>
                        )}
                      </Col>
                    </Row>
                  </Panel>
                );
              })}
            </Collapse>
          );
          this.setState({ pagosHtml: html });
        };
      });
    this.setState({ loading: false });
  }
  cerrarFacturasOrdenDeCompra() {
    this.props.cerrarFacturasOrdenDeCompra();
  }
  render() {
    const { confirmacionData } = this.state;
    return (
      <>
        <ModalItem
          title="Facturas Orden De Compra"
          visible={this.props.visible}
          spinning={this.state.loading}
          onCancel={this.cerrarFacturasOrdenDeCompra.bind(this)}
          paddingTop
        >
          {this.state.pagosHtml}
        </ModalItem>
        <ModalItem
          title="Confirmar cancelación de factura"
          visible={this.state.confirmacionVisible}
          spinning={this.state.confirmacionLoading}
          onCancel={this.cerrarConfirmacion}
          onOk={this.confirmarCancelacionConPoliza}
          okText="Continuar"
          cancelText="Cancelar"
          footer
          paddingTop
          width={window.innerWidth > 1000 ? "55%" : "95%"}
        >
          {confirmacionData && (
            <>
              <p style={{ marginTop: 10 }}>{confirmacionData.message}</p>
              {confirmacionData.recepcionesAfectadas.length > 0 && (
                <Table
                  size="small"
                  pagination={false}
                  rowKey={(record, index) => `${record.codigoRemision || ""}-${index}`}
                  dataSource={confirmacionData.recepcionesAfectadas}
                  columns={[
                    {
                      title: "Remisión",
                      dataIndex: "codigoRemision",
                      key: "codigoRemision",
                    },
                    {
                      title: "Fecha",
                      dataIndex: "fecha",
                      key: "fecha",
                      render: (fecha) =>
                        fecha ? moment(fecha).locale("es").format("ll") : "-",
                    },
                    {
                      title: "Monto",
                      dataIndex: "monto",
                      key: "monto",
                      align: "right",
                      render: (monto) => dineroDisabledMask(monto || 0),
                    },
                  ]}
                  style={{ marginBottom: 10 }}
                />
              )}
              <p style={{ textAlign: "right", fontWeight: "bold" }}>
                Total saldo tránsito:{" "}
                {dineroDisabledMask(confirmacionData.totalSaldoTransito || 0)}
              </p>
            </>
          )}
        </ModalItem>
        <ModalEditarDatosFactura
          visible={this.state.modalEditarDatos}
          facturaId={this.state.modalEditarDatosId}
          onCancel={() => this.cerrarEditarDatosFactura(false)}
          onSuccess={() => this.cerrarEditarDatosFactura(true)}
        />
        <RelacionarEntregasModal
          visible={this.state.modalEntregas}
          facturaId={this.state.modalEntregasFactura?._id}
          ordenesDeCompraIds={
            this.state.modalEntregasFactura?.ordenesDeCompraIds?.length
              ? this.state.modalEntregasFactura.ordenesDeCompraIds
              : [this.state.modalEntregasFactura?.ordenDeCompraId]
          }
          renglonesFactura={(this.state.modalEntregasFactura?.insumos || [])
            .filter((valueInsumo) => (valueInsumo.cantidad || 0) > 0)
            .map((valueInsumo) => ({
              insumoOrdenId: valueInsumo._id,
              cantidadAFacturar: valueInsumo.cantidad,
            }))}
          seleccionInicial={{}}
          onCancel={() => this.cerrarRelacionarEntregas()}
          onConfirm={() => this.cerrarRelacionarEntregas()}
        />
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    headersToken: state.user.headersToken,
    empresaId: state.empresa.id,
    permisoEditarFacturasOrdenDeCompra: state.user.tipo === 0 || state.user.permisos.find(valueTodos => valueTodos.permisoId.toString() === "6a94a06bd51a26d4c5731dcb")?.activado,
    // Mientras no exista un Permiso propio (hace falta su ObjectId, no hay seed de
    // permisos en el repo), manda el de editar facturas: quien puede editarlas puede
    // declarar que entregas amparan. Al crearlo, sustituir los 24 ceros.
    permisoRelacionarEntregasFactura:
      state.user.tipo === 0 ||
      (state.user.permisos.find(
        (valueTodos) => valueTodos.permisoId.toString() === "000000000000000000000000"
      )?.activado ??
        state.user.permisos.find(
          (valueTodos) => valueTodos.permisoId.toString() === "6a94a06bd51a26d4c5731dcb"
        )?.activado),
  };
};

export default connect(mapStateToProps)(FacturasOrdenDeCompra);
